module.exports = __webpack_public_path__ + "img/icon-computer@2x.877370c.png";